<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<v-dialog
		persistent
		v-model="showDialog"
		width="500">
		<v-card>
			<v-form ref="form">
				<v-card-title
					class="headline"
					primary-title
				>
					{{this.edit? "Edycja aneksu" : "Dołączenie aneksu"}}
				</v-card-title>
				<v-card-text>
					<v-flex xs12>
						<v-menu
							ref="menu"
							v-model="menu"
							:close-on-content-click="false"
							:return-value.sync="annex.signDate"
							transition="scale-transition"
							offset-y
							full-width
							min-width="290px"
						>
							<template v-slot:activator="{ on }">
								<v-text-field
									browser-autocomplete="off"
									v-model="annex.signDate"
									label="Data podpisania"
									aria-label="annex sign date"
									for="annex-popup-sign-date"
									id="annex-popup-sign-date"
									:rules="rules"
									prepend-icon="event"
									readonly
									v-on="on"
								></v-text-field>
							</template>
							<v-date-picker :first-day-of-week="1"
								v-model="annex.signDate" no-title scrollable locale="pl-PL">
								<v-spacer></v-spacer>
								<v-btn text color="primary" @click="menu = false">Anuluj</v-btn>
								<v-btn text color="primary" @click="$refs.menu.save(annex.signDate)">OK</v-btn>
							</v-date-picker>
						</v-menu>
					</v-flex>
					<div v-if="!edit">
						<v-flex xs12>
							<v-layout row>
								<v-flex xs6>
									<v-btn @click="$refs.file.click()" class="ma-2">
										{{annex.file ? "Podmień aneks" : "Dodaj aneks"}}
									</v-btn>
								</v-flex>
								<v-flex xs6>
									<v-btn @click="$refs.attachments.click()" class="ma-2">
										{{"Dodaj załączniki"}}
									</v-btn>
								</v-flex>
							</v-layout>
						</v-flex>
						<input :rules="rules" type="file" ref="file" id="annex-file-input" v-show="false"
							:accept="acceptedFiles"
							v-on:change="handleAnnexUpload">
						<input :rules="rules" type="file" multiple v-show="false" ref="attachments"
							:accept="acceptedFiles"
							id="annex-attachments-input"
							v-on:change="handleAttachmentsUpload">

						<div v-if="annex.file">
							<strong class="mr-2">Aneks: </strong>{{annex.file.name}}
							<v-icon @click="deleteAnnexFile" style="cursor: pointer" class="ml-2">delete</v-icon>
						</div>
						<div v-for="(item, index) in annex.attachments" :key="index">
							<strong class="mr-2">{{'Załącznik ' + (index + 1)}}:</strong>
							{{item.name}}
							<v-icon @click="deleteAttachment(index)" style="cursor: pointer" class="ml-2">delete
							</v-icon>
						</div>
					</div>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						v-if="!edit"
						color="primary"
						@click="addAnnex">
						Zapisz
					</v-btn>
					<v-btn
						v-else
						color="primary"
						@click="updateAnnex">
						Zapisz
					</v-btn>
					<v-btn
						color="primary"
						flat
						@click="closeModal">
						Anuluj
					</v-btn>
				</v-card-actions>
			</v-form>

		</v-card>
	</v-dialog>
</template>

<script>
	import {Files} from "../../../../utils/Files";
	import {Annex} from "@/api/generated/Annex";

	export default {
		name: "AnnexPopup",

		data() {
			return {
				showDialog: this.isOpen,
				annex: {
					signDate: null,
					file: null,
					attachments: [],
				},
				menu: false,
				fileChanged: false,

				rules: [v => !!v || "Pole wymagane!"],
			};
		},

		methods: {
			closeModal() {
				this.$refs.form.reset();
				if (!this.edit) {
					this.$refs.file.value = "";
				}
				this.annex = {
					signDate: null,
					file: null,
					attachments: [],
				};
				this.$emit("close");
			},
			async addAnnex() {
				if (!await this.$refs.form.validate() || (this.$refs.file.files[0] === undefined)) {
					return;
				}
				let formData = new FormData();
				formData.append("file", this.annex.file);
				for (let i = 0; i < this.annex.attachments.length; ++i) {
					formData.append("attachments", this.annex.attachments[i]);
				}
				await this.$http.post(process.env.VUE_APP_API_URL + "/annex?projectId="
					.concat(this.$route.params.projectId)
					.concat("&signDate=" + this.annex.signDate), formData, {
					headers: {
						"Content-Type": "multipart/form-data",
					},
				});
				this.$emit("refresh");
				this.closeModal();
			},
			async updateAnnex() {
				if (!await this.$refs.form.validate()) {
					return;
				}
				await Annex.putUpdateAnnexData(this, this.$route.params.projectId, this.item.id, this.annex.signDate,
					successResponse => {
						this.$messagesBus.$emit("success", "Aneks został zaktualizowany", successResponse);
						this.$emit("refresh");
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się zaktualizować aneksu", errorResponse);
					});
				this.closeModal();
			},
			async handleAnnexUpload () {
				if (this.hasIncorrectFilesExtension(this.$refs.file.files)) {
					Files.methods.clearFileInput('annex-file-input');
          this.$messagesBus.$emit("error", "Wgrywanie plików w tym formacie jest niedozwolone. " +
              "Dozwolone formaty plików to " + this.acceptedFiles.split(",").join(", "));
          return;
				}
				let validFilesSize = await Files.methods.validateFilesSize(this, this.$refs.file.files);
				if (!validFilesSize) {
					Files.methods.clearFileInput("annex-file-input");
					return;
				}
				this.annex.file = this.$refs.file.files[0];
			},
			async handleAttachmentsUpload () {
				if (this.hasIncorrectFilesExtension(this.$refs.attachments.files)) {
					Files.methods.clearFileInput('annex-attachments-input');
          this.$messagesBus.$emit("error", "Wgrywanie plików w tym formacie jest niedozwolone. " +
              "Dozwolone formaty plików to " + this.acceptedFiles.split(",").join(", "));
          return;
				}

				let validFilesSize = await Files.methods.validateFilesSize(this, this.$refs.attachments.files);
				if (!validFilesSize) {
					Files.methods.clearFileInput("annex-attachments-input");
					return;
				}
				for (let i = 0; i < this.$refs.attachments.files.length; ++i) {
					this.annex.attachments.push(this.$refs.attachments.files[i]);
				}
			},
			deleteAnnexFile () {
				this.annex.file = null;
			},
			deleteAttachment (index) {
				this.annex.attachments.splice(index, 1);
			},
		},

		watch: {
			isOpen: {
				immediate: true,
				handler(val) {
					this.showDialog = val;
					this.annex.signDate = this.item.signDate;
					if (this.item.annex !== undefined) {
						this.annex.file = this.item.annex.fileName;
					}
				},
			},
		},

		props: {
			isOpen: {type: Boolean, default: false},
			edit: {type: Boolean, default: false},
			item: {
				type: Object, default() {
					return {};
				},
			},
		},
	};
</script>

<style scoped>

</style>
